import React from 'react';
import PageContainer from '../components/common/PageContainer';
import Layout from '../components/common/Layout';
import FacilityViewScreen from '../components/screens/facilities2/FacilityViewScreen';

export default function FacilityView(props) {
  return (
    <Layout headerTitle="View Facility">
      <PageContainer id="view_facility">
        <FacilityViewScreen props={props} />
      </PageContainer>
    </Layout>
  );
}
